import Http from 'services/http2';
import User from 'services/user2';
import Modal from 'services/modal';
import Util from 'lib/util';

const BaseService = {
  //通用保存接口
  async save(config: any = {}, cb: Function = () => {}, dispatch: Function) {
    let successMsg = '操作成功';
    let apiPathUrl = '/api/cloudCenter?btnId=005';
    if (typeof config.successMsg === 'string') {
      successMsg = config.successMsg;
      delete config.successMsg;
    }

    if (Util.isEmpty(config.companyCode) && Util.isEmpty(config.erpOrgCode)) {
      config.companyCode = User.getCompanyCode();
    }

    let rs;
    Modal.showLoading(dispatch);
    await Http.post(apiPathUrl, config).then(response => {
      Modal.hideLoading(dispatch);
      rs = response;
      if (!response) {
        return;
      } else if (response.success) {
        if (response.data?.checkResult !== 'Dynamic_Inquiry_ERR_181') {
          Modal.showTip(successMsg, dispatch);
        }
        cb(response.data);
      } else if (response.errorMsg) {
        Modal.showError(response.errorMsg, dispatch);
      }
    });
    return rs;
  }
};

export default BaseService;
